var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashTurnOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06966 12L8.89419 15V20H14.5432V15L17.3678 12V7H6.06966V12ZM7.95268 9H15.4847V11.17L12.6602 14.17V18H10.7772V14.17L7.95268 11.17V9ZM10.7772 0H12.6602V3H10.7772V0ZM3.71777 3.874L5.04907 2.46L7.04695 4.58L5.71565 5.995L3.71777 3.874ZM16.3886 4.582L18.3874 2.462L19.7178 3.878L17.7189 5.998L16.3886 4.582Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4.60547,
    width: 3,
    height: 24.9415,
    transform: "rotate(-60 0 4.60547)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashTurnOff);
export default __webpack_public_path__ + "static/media/Flash-turn-off.eb38951e3bd920f31f64a0d546ad751b.svg";
export { ForwardRef as ReactComponent };